"use strict";

module.exports = "<svg version=\"1.1\" class=\"dibsvg-svg dibsvg-arrow-right\" viewBox=\"-8.5 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <path d=\"M1,0c0.3,0,0.6,0.1,0.8,0.3l13,15c0.3,0.4,0.3,0.9,0,1.3l-13,15c-0.4,0.4-1,0.5-1.4,0.1 c-0.4-0.4-0.5-1-0.1-1.4L12.6,16L0.2,1.7c-0.4-0.4-0.3-1,0.1-1.4C0.5,0.1,0.8,0,1,0z\" />\n</svg>";


//////////////////
// WEBPACK FOOTER
// ./~/dibs-vg/dist/templateString/arrow-right.js
// module id = 1671
// module chunks = 4 7